module.exports = "<p>\n  404 <a routerLink=\"/\">Go Home?</a>\n</p>\n"